import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import dataPanel from "../../service/dataPanel.json";
import FontAwesome from "../../utility/fontAwesome/fontAwesome";
const Numbers = () => {
  return (
    <div className="container" style={{ fontSize: "18px" }}>
      <span style={{ fontSize: "25px" }}>خط اختصاصی</span>
      <br />
      <span style={{ fontSize: "30px" }}>
        برای استفاده از خطوط ارسال پیامک حتما باید پنل اس ام اس داشته باشید.
      </span>
      <br />
      <br />
      در تمام پنل ها خطوط رند عمومی و 14 رقمی اختصاصی بصورت رایگان اعطا میشود.
      <br />
      تعرفه های این برگه برای کسانی است که علاوه بر خطوط رایگان, شماره های رند
      اختصاصی اضافی نیاز دارند.
      <br />
      قبل از خرید شماره اختصاصی ابتدا پنل پیامک مورد نیاز را انتخاب و تهیه کنید.
      <br />
      قیمت های خطوط به تومان میباشد!
      <br />
      <span style={{ fontSize: "30px" }}>قیمت شماره اختصاصی اپراتور 1000</span>
      <table class="table table-striped table-primary">
        <thead className="bg-primary">
          <tr>
            <th scope="col">ارقام</th>
            <th scope="col">نمونه شماره</th>
            <th scope="col">غیرسفارشی کاربران</th>
            <th scope="col">سفارشی کاربران</th>
            <th scope="col">غیرسفارشی نمایندگان</th>
            <th scope="col">سفارشی نمایندگان</th>
          </tr>
        </thead>
        <thead className="bg-primary">
          <tr>
            <th scope="col" colSpan="6">
              <FontAwesome icon={faPaperPlane} title="ارسال" />
            </th>
          </tr>
        </thead>
        <tbody>
          {dataPanel.operator1000.map((p) => (
            <tr>
              <th scope="row">{p.figures}</th>
              <td>{p.sampleNumber}</td>
              <td>{p.nonCustomUsers}</td>
              <td>{p.customUsers}</td>
              <td>{p.nonCustomAgents}</td>
              <td>{p.customRepresentatives}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
      <span style={{ fontSize: "30px" }}>قیمت شماره اختصاصی اپراتور 2000</span>
      <table class="table table-striped table-primary">
        <thead className="bg-primary">
          <tr>
            <th scope="col">ارقام</th>
            <th scope="col">نمونه شماره</th>
            <th scope="col">کاربران</th>
            <th scope="col">نمایندگان</th>
          </tr>
        </thead>
        <tbody>
          {dataPanel.operator2000.map((p) => (
            <tr>
              <th scope="row">{p.figures}</th>
              <td>{p.sampleNumber}</td>
              <td>{p.users}</td>
              <td>{p.reseller}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
      <span style={{ fontSize: "30px" }}>قیمت شماره اختصاصی اپراتور 3000</span>
      <table class="table table-striped table-primary">
        <thead className="bg-primary">
          <tr>
            <th scope="col">ارقام</th>
            <th scope="col">نمونه شماره</th>
            <th scope="col">کاربران</th>
            <th scope="col">نمایندگان</th>
          </tr>
        </thead>
        <tbody>
          {dataPanel.operator3000.map((p) => (
            <tr>
              <th scope="row">{p.figures}</th>
              <td>{p.sampleNumber}</td>
              <td>{p.users}</td>
              <td>{p.reseller}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
      <span style={{ fontSize: "30px" }}>قیمت شماره اختصاصی اپراتور 50001</span>
      <table class="table table-striped table-primary">
        <thead className="bg-primary">
          <tr>
            <th scope="col">ارقام</th>
            <th scope="col">نمونه شماره</th>
            <th scope="col">کاربران</th>
            <th scope="col">نمایندگان</th>
          </tr>
        </thead>
        <tbody>
          {dataPanel.operator50001.map((p) => (
            <tr>
              <th scope="row">{p.figures}</th>
              <td>{p.sampleNumber}</td>
              <td>{p.users}</td>
              <td>{p.reseller}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
      <span style={{ fontSize: "30px" }}>قیمت شماره اختصاصی اپراتور 50002</span>
      <table class="table table-striped table-primary">
        <thead className="bg-primary">
          <tr>
            <th scope="col">ارقام</th>
            <th scope="col">نمونه شماره</th>
            <th scope="col">کاربران</th>
            <th scope="col">نمایندگان</th>
          </tr>
        </thead>
        <tbody>
          {dataPanel.operator50002.map((p) => (
            <tr>
              <th scope="row">{p.figures}</th>
              <td>{p.sampleNumber}</td>
              <td>{p.users}</td>
              <td>{p.reseller}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
      <span style={{ fontSize: "30px" }}>قیمت شماره اختصاصی اپراتور 50004</span>
      <table class="table table-striped table-primary">
        <thead className="bg-primary">
          <tr>
            <th scope="col">ارقام</th>
            <th scope="col">نمونه شماره</th>
            <th scope="col">کاربران</th>
            <th scope="col">نمایندگان</th>
          </tr>
        </thead>
        <tbody>
          {dataPanel.operator50004.map((p) => (
            <tr>
              <th scope="row">{p.figures}</th>
              <td>{p.sampleNumber}</td>
              <td>{p.users}</td>
              <td>{p.reseller}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
      <span style={{ fontSize: "30px" }}>قیمت شماره اختصاصی اپراتور 50005</span>
      <table class="table table-striped table-primary">
        <thead className="bg-primary">
          <tr>
            <th scope="col">ارقام</th>
            <th scope="col">نمونه شماره</th>
            <th scope="col">کاربران</th>
            <th scope="col">نمایندگان</th>
          </tr>
        </thead>
        <tbody>
          {dataPanel.operator50005.map((p) => (
            <tr>
              <th scope="row">{p.figures}</th>
              <td>{p.sampleNumber}</td>
              <td>{p.users}</td>
              <td>{p.reseller}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
      <span style={{ fontSize: "30px" }}>قیمت شماره اختصاصی اپراتور 50009</span>
      <table class="table table-striped table-primary">
        <thead className="bg-primary">
          <tr>
            <th scope="col">ارقام</th>
            <th scope="col">نمونه شماره</th>
            <th scope="col">کاربران</th>
            <th scope="col">نمایندگان</th>
          </tr>
        </thead>
        <tbody>
          {dataPanel.operator50009.map((p) => (
            <tr>
              <th scope="row">{p.figures}</th>
              <td>{p.sampleNumber}</td>
              <td>{p.users}</td>
              <td>{p.reseller}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
      <span style={{ fontSize: "30px" }}>
        قیمت خطوط اختصاصی اپراتور۰۲۱ و ۰۲۶
      </span>
      <table class="table table-striped table-primary">
        <thead className="bg-primary">
          <tr>
            <th scope="col">ارقام</th>
            <th scope="col">نمونه شماره</th>
            <th scope="col">کاربران</th>
            <th scope="col">نمایندگان</th>
          </tr>
        </thead>
        <tbody>
          {dataPanel.operator021and026.map((p) => (
            <tr>
              <th scope="row">{p.figures}</th>
              <td>{p.sampleNumber}</td>
              <td>{p.users}</td>
              <td>{p.reseller}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
      <span style={{ color: "red" }}>غیر سفارشی:</span>شماره هایی که بطور تصادفی
      توسط مخابرات انتخاب میشود.
      <br />
      <span style={{ color: "red" }}>سفارشی:</span> شماره هایی که خود شما انتخاب
      میکنید
    </div>
  );
};

export default Numbers;
